export default "__VITE_ASSET__D5um1Ntp__"